/**
 *   Docutain SDK Capacitor
 *   Copyright (c) INFOSOFT Informations- und Dokumentationssysteme GmbH. All rights reserved.
 *
 *   Docutain SDK Capacitor is a commercial product and requires a license.
 *   Details found in the LICENSE file in the root directory of this source tree.
 */
/**
 * Available PDF page formats when generating PDF documents.
 *
 * @since 1.0.0
 */
export var PDFPageFormat;
(function (PDFPageFormat) {
    /**
     *
     * @since 1.0.0
     */
    PDFPageFormat["FitToPages"] = "FIT_TO_PAGES";
    /**
     *
     * @since 1.0.0
     */
    PDFPageFormat["A4"] = "A4";
    /**
     *
     * @since 1.0.0
     */
    PDFPageFormat["A4Landscape"] = "A4_LANDSCAPE";
    /**
     *
     * @since 1.0.0
     */
    PDFPageFormat["A5"] = "A5";
    /**
     *
     * @since 1.0.0
     */
    PDFPageFormat["A5Landscape"] = "A5_LANDSCAPE";
    /**
     *
     * @since 1.0.0
     */
    PDFPageFormat["Letter"] = "LETTER";
    /**
     *
     * @since 1.0.0
     */
    PDFPageFormat["LetterLandscape"] = "LETTER_LANDSCAPE";
    /**
     *
     * @since 1.0.0
     */
    PDFPageFormat["Legal"] = "LEGAL";
    /**
     *
     * @since 1.0.0
     */
    PDFPageFormat["LegalLandscape"] = "LEGAL_LANDSCAPE";
})(PDFPageFormat || (PDFPageFormat = {}));
/**
 * Available filters that can be applied on scanned documents.
 *
 * @since 1.0.0
 */
export var ScanFilter;
(function (ScanFilter) {
    /**
     *
     * @since 1.0.0
     */
    ScanFilter["Auto"] = "AUTO";
    /**
     *
     * @since 1.0.0
     */
    ScanFilter["Gray"] = "GRAY";
    /**
     *
     * @since 1.0.0
     */
    ScanFilter["BlackWhite"] = "BLACKWHITE";
    /**
     *
     * @since 1.0.0
     */
    ScanFilter["Original"] = "ORIGINAL";
    /**
     *
     * @since 1.0.0
     */
    ScanFilter["Text"] = "TEXT";
    /**
     *
     * @since 1.0.0
     */
    ScanFilter["Auto2"] = "AUTO2";
    /**
     *
     * @since 1.0.0
     */
    ScanFilter["Illustration"] = "ILLUSTRATION";
})(ScanFilter || (ScanFilter = {}));
/**
 * Available page source types when generating image files from scanned or imported pages.
 *
 * @since 1.0.0
 */
export var PageSourceType;
(function (PageSourceType) {
    /**
     * Uncut, unfiltered image as delivered by camera.
     *
     * @since 1.0.0
     */
    PageSourceType["Original"] = "ORIGINAL";
    /**
     * Cut and filtered image.
     *
     * @since 1.0.0
     */
    PageSourceType["CutFilter"] = "CUT_FILTER";
    /**
     * Cut only image, no filter.
     *
     * @since 1.0.0
     */
    PageSourceType["CutOnly"] = "CUT_ONLY";
})(PageSourceType || (PageSourceType = {}));
/**
 * Available log level for defining the level of logging detail
 *
 * @since 1.0.0
 */
export var LogLevel;
(function (LogLevel) {
    LogLevel["Disable"] = "DISABLE";
    LogLevel["Assert"] = "ASSERT";
    LogLevel["Error"] = "ERROR";
    LogLevel["Warning"] = "WARNING";
    LogLevel["Info"] = "INFO";
    LogLevel["Debug"] = "DEBUG";
    LogLevel["Verbose"] = "VERBOSE";
})(LogLevel || (LogLevel = {}));
/**
 * Available sources for the document scanner.
 *
 * @since 1.0.0
 */
export var Source;
(function (Source) {
    /**
     * Scan a document by using the devices camera.
     *
     * @since 1.0.0
     */
    Source["Camera"] = "CAMERA";
    /**
     * Scan a document from the provided image.
     *
     * @since 1.0.0
     */
    Source["Image"] = "IMAGE";
    /**
     * Open an image picker in single selection mode and scan a document from the selected image.
     *
     * @since 1.0.0
     */
    Source["Gallery"] = "GALLERY";
    /**
     * Open an image picker in multi selection mode and scan documents from the selected images.
     *
     * @since 1.0.0
     */
    Source["GalleryMultiple"] = "GALLERY_MULTIPLE";
    /**
     * Same as [CAMERA] but shows an additional import button which the user can use to import files as well.
     *
     * @since 6.0.0
     */
    Source["CameraImport"] = "CAMERA_IMPORT";
})(Source || (Source = {}));
/**
 * Available statusbar appearances.
 *
 * @since 2.0.5
 */
export var StatusBarAppearance;
(function (StatusBarAppearance) {
    /**
     * Light appearance.
     *
     * @since 2.0.5
     */
    StatusBarAppearance["Light"] = "LIGHT";
    /**
     * Dark appearance.
     *
     * @since 2.0.5
     */
    StatusBarAppearance["Dark"] = "DARK";
})(StatusBarAppearance || (StatusBarAppearance = {}));
/**
 * Available navigationbar appearances.
 *
 * @since 2.0.5
 */
export var NavigationBarAppearance;
(function (NavigationBarAppearance) {
    /**
     * Light appearance.
     *
     * @since 2.0.5
     */
    NavigationBarAppearance["Light"] = "LIGHT";
    /**
     * Dark appearance.
     *
     * @since 2.0.5
     */
    NavigationBarAppearance["Dark"] = "DARK";
})(NavigationBarAppearance || (NavigationBarAppearance = {}));
//# sourceMappingURL=definitions.js.map